export default __webpack_public_path__ + "media/src/features/footer/assets/twitter-14e24e19135a193d3928747e9eb2a314.png";